import { getRequest, postRequest, putRequest, replaceInUrl } from './index';
import apiEndpoints from './apiEndpoints';

export const getTriggerOrderQuoteRequest = ({
  accountUid,
  symbolCode,
  side,
  quantity,
  targetPrice,
  priceAtSubmission,
  isSegregated,
}) =>
  getRequest(
    replaceInUrl(apiEndpoints.accounts.triggerOrderQuotes, { accountUid }),
    {
      symbolCode,
      side,
      quantity,
      targetPrice,
      priceAtSubmission,
      isSegregated,
    },
  );

export const executeTriggerOrderQuoteRequest = ({ accountUid, QuoteUid }) =>
  postRequest(
    replaceInUrl(apiEndpoints.accounts.triggerOrderQuotes, { accountUid }),
    null,
    { accountUid, QuoteUid },
  );

export const cancelTriggerOrderRequest = ({ accountUid, triggerOrderUid }) =>
  putRequest(
    replaceInUrl(apiEndpoints.accounts.cancelTriggerOrder, {
      accountUid,
      triggerOrderUid,
    }),
  );
